import { render, staticRenderFns } from "./StaySummary.vue?vue&type=template&id=b3ef3966&"
import script from "./StaySummary.vue?vue&type=script&lang=ts&"
export * from "./StaySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3ef3966')) {
      api.createRecord('b3ef3966', component.options)
    } else {
      api.reload('b3ef3966', component.options)
    }
    module.hot.accept("./StaySummary.vue?vue&type=template&id=b3ef3966&", function () {
      api.rerender('b3ef3966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/StaySummary.vue"
export default component.exports